import { useEffect, useState } from "react";
import TechStackSection from "./TechStackSection";
import TechStackTerminal from "./TechStackTerminal";
import CompanyTerminal from "./CompanyTerminal";
import trustedCompanies from "../data/trustedCompanies";

const TECHSTACK_HERO_STORAGE_KEY = "techStackHeroOpen";

export default function TechStackHero({ defaultOpen = false, onCompanyClick, isOpen: controlledOpen, onToggle }) {
  const isControlled = typeof controlledOpen === "boolean" && typeof onToggle === "function";
  const [isOpen, setIsOpen] = useState(() => {
    if (typeof window === "undefined") return defaultOpen;
    const stored = window.sessionStorage.getItem(TECHSTACK_HERO_STORAGE_KEY);
    if (stored === "1") return true;
    if (stored === "0") return false;
    return defaultOpen;
  });

  useEffect(() => {
    if (isControlled) return;
    if (typeof window === "undefined") return;
    window.sessionStorage.setItem(TECHSTACK_HERO_STORAGE_KEY, isOpen ? "1" : "0");
  }, [isOpen, isControlled]);

  useEffect(() => {
    if (isControlled) return;
    return () => {
      if (typeof window === "undefined") return;
      window.sessionStorage.removeItem(TECHSTACK_HERO_STORAGE_KEY);
    };
  }, [isControlled]);

  const open = isControlled ? controlledOpen : isOpen;
  const handleToggle = isControlled ? onToggle : () => setIsOpen((v) => !v);

  return (
    <div className="techstackhero-area">
      <div className="mt-0">
        <TechStackSection onToggle={handleToggle} isOpen={open} />
      </div>
      <div
        className={`mt-0 overflow-hidden transform-gpu transition-[max-height,transform] duration-700 ease-out will-change-[max-height,transform] ${
          open
            ? "max-h-[4200px] translate-y-0"
            : "max-h-0 -translate-y-2 pointer-events-none"
        }`}
        aria-hidden={!open}
      >
        <TechStackTerminal />
        <CompanyTerminal
          companies={trustedCompanies}
          enableDetailOverlay
          onCompanyClick={onCompanyClick}
        />
      </div>
    </div>
  );
}
